import { IconButton } from "@tvg/fuse/button";
import classNames from "classnames";
import React from "react";
import { HeaderIconProps } from "../../../common/types/navigation";
import styles from "./IconLink.module.css";

const IconLink: React.FC<HeaderIconProps> = ({
  href,
  icon,
  label,
  onClick,
  className,
  "data-testid": dataTestId,
  ariaLabel,
  notification = "",
}) => (
  <IconButton
    href={href}
    text={label}
    icon={icon}
    dataTestId={dataTestId}
    aria-label={ariaLabel || label}
    className={classNames(styles.iconLink, className)}
    onClick={onClick}
    size={{ xxs: "small", l: "medium" }}
    notification={notification}
  />
);

export default IconLink;
